export const SUPPORT_EMAIL = 'contact@aibitsoft.com'
export const APP_NAME = 'Timeless Trends Salon'
export const WEBSITE_URL = 'https://salon.aibitsoft.com'

export const LEGAL_ROUTES = {
  privacy: '/privacypolicy',
  termsOfService: '/termsofservice',
  termsOfUse: '/termsofuse',
  contact: '/contact',
  deleteAccount: '/delete-account',
}
